import * as React from 'react'
import { Calendar } from '../calendar'
import { useDateTimePickerContext } from './date-time-picker-context'

export function DateTimePickerCalendar(props?: DateTimePickerCalendar.Props) {
  const { value, setDateValue } = useDateTimePickerContext()

  return (
    <Calendar
      mode="single"
      selected={value}
      onSelect={(value) => {
        if (!value) return
        setDateValue(value)
      }}
      {...props}
    />
  )
}

export namespace DateTimePickerCalendar {
  export interface Props
    extends Omit<React.ComponentProps<typeof Calendar>, 'mode' | 'selected' | 'onSelect'> {}
}
